var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessingSaturated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ProcessingSaturated",
    "data-name": "ProcessingSaturated",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)",
    opacity: 0.316
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#d7e49e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12679",
    "data-name": "Path 12679",
    d: "M822.664,634.458c-8.668-4.985-29.182,13.223-34.168,21.891A18.106,18.106,0,1,0,819.885,674.4c4.985-8.668,11.447-34.961,2.779-39.947",
    transform: "translate(-753.695 -601.956)",
    fill: "#bbd36c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12680",
    "data-name": "Path 12680",
    d: "M822.9,633.066c-9.6-5.52-30.569,13.242-35.8,22.332a19.3,19.3,0,0,0,33.459,19.245c4.768-8.292,12.183-35.914,2.34-41.577m-4.409,40.386a16.911,16.911,0,1,1-29.318-16.863c4.726-8.22,24.74-25.937,32.536-21.452,7.719,4.439,1.538,30.048-3.218,38.315",
    transform: "translate(-753.338 -601.599)",
    fill: "#30662c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12681",
    "data-name": "Path 12681",
    d: "M814.132,660.616c-3.8-2.185-10.015,1.489-12.763,6.267s-.992,8.85,2.811,11.038,8.2,1.656,10.952-3.122,2.8-12-1-14.183",
    transform: "translate(-756.927 -608.063)",
    fill: "#c68a79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12682",
    "data-name": "Path 12682",
    d: "M814.37,659.235c-3.738-2.149-10.685.261-14.393,6.705-2.834,4.928-1.559,9.9,3.25,12.665s9.747,1.37,12.583-3.559c3.706-6.445,2.3-13.663-1.44-15.812m-.631,14.622c-2.177,3.783-5.662,4.785-9.321,2.678s-4.549-5.621-2.37-9.4c2.379-4.138,7.982-7.638,11.132-5.828s2.94,8.416.56,12.553",
    transform: "translate(-756.569 -607.715)",
    fill: "#906d5e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingSaturated);
export default __webpack_public_path__ + "static/media/ProcessingSaturated.3220bef1eec51aaf3edd9aef447b9534.svg";
export { ForwardRef as ReactComponent };